import { IAccessControlState } from "reducers/access-control-reducers";
import { ACCESS_CONTROL } from "constants/action-types";

export const setAccessControlError = (payload: IAccessControlState["error"]) => ({
    type: ACCESS_CONTROL.ERROR.SET,
    payload,
});

export const setAccessControlPermission = (payload: boolean) => ({
    type: ACCESS_CONTROL.HAS.ACCESS,
    payload,
});

export const processAccessControlError = (payload: IAccessControlState["error"]) => ({
    type: ACCESS_CONTROL.ERROR.PROCESS,
    payload,
});
